import { createScanbotDocumentSdkAdapter } from "./ScanbotDocumentSdkAdapter";

export const DEFAULT_SDK_TTL_MS = 55_000;
export const DEFAULT_SDK_EXPIRED_ERROR_SUBSTRING = "Trial period ended";

export class DocumentSdkManager {
  constructor({ adapter, ttlMs = DEFAULT_SDK_TTL_MS, expiredErrorSubstring = DEFAULT_SDK_EXPIRED_ERROR_SUBSTRING }) {
    this.adapter = adapter;
    this.ttlMs = ttlMs;
    this.expiredErrorSubstring = expiredErrorSubstring;

    this.sdk = null;
    this.sdkInitializedAtMs = 0;
    this.initPromise = null;
  }

  isSdkValid() {
    if (!this.sdk) return false;
    const ageMs = Date.now() - this.sdkInitializedAtMs;
    return ageMs < this.ttlMs;
  }

  async initialize() {
    if (this.initPromise) return await this.initPromise;

    this.initPromise = (async () => {
      const sdk = await this.adapter.initialize();
      this.sdk = sdk;
      this.sdkInitializedAtMs = Date.now();
      return sdk;
    })();

    try {
      return await this.initPromise;
    } finally {
      this.initPromise = null;
    }
  }

  async getSdk() {
    if (this.isSdkValid()) return this.sdk;
    return await this.initialize();
  }

  invalidateSdk() {
    this.sdk = null;
    this.sdkInitializedAtMs = 0;
  }

  isExpiredError(error) {
    const message = error instanceof Error ? error.message : String(error);
    return message.includes(this.expiredErrorSubstring);
  }

  async withSdk(operation) {
    const sdk = await this.getSdk();

    try {
      return await operation(sdk);
    } catch (error) {
      if (!this.isExpiredError(error)) {
        throw error;
      }

      this.invalidateSdk();
      const refreshedSdk = await this.getSdk();
      return await operation(refreshedSdk);
    }
  }
}

const defaultDocumentSdkManager = new DocumentSdkManager({
  adapter: createScanbotDocumentSdkAdapter({ licenseKey: "" }),
});

export default defaultDocumentSdkManager;
